'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./storeLocator/storeLocator'));
    processInclude(require('./clickandcollect/clickAndCollectLocator'));
    processInclude(require('./correoArgLocator/correoArgLocator'));
    processInclude(require('./pickItLocator.js'));
});
